import { render } from "./IndexLama.vue?vue&type=template&id=3a6cb126"
import script from "./IndexLama.vue?vue&type=script&lang=js"
export * from "./IndexLama.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__